module.exports = __webpack_public_path__ + "img/logo.5c721587.webp";